import { clientPortalRequest, buildClientQuery, resolveVendorDirectoryApiBase } from "./clientPortalFetch";
import { ensureCsrfToken } from "./apiClient";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function listVendorDirectoryImportJobs(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones${buildClientQuery(params)}`);
}

export function getVendorDirectoryImportJob(clientViewId, importJobId) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}`);
}

export function createVendorDirectoryImportJob(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function uploadVendorDirectoryImportFile(clientViewId, importJobId, file) {
  const token = await ensureCsrfToken();
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/importaciones/${importJobId}/archivo`,
    {
      method: "POST",
      headers: { "X-CSRF-Token": token },
      body: formData,
      credentials: "include",
    }
  );
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(body?.message || `Upload failed (${response.status})`);
  }
  return body;
}

export function inspectVendorDirectoryImportFile(clientViewId, importJobId, params = {}) {
  return clientPortalRequest(
    `${base(clientViewId)}/importaciones/${importJobId}/inspeccion${buildClientQuery(params)}`
  );
}

export function saveVendorDirectoryImportMapping(clientViewId, importJobId, body) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/mapeo`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function validateVendorDirectoryImport(clientViewId, importJobId) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/validar`, {
    method: "POST",
  });
}

export function markVendorDirectoryImportReady(clientViewId, importJobId) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/listo`, {
    method: "POST",
  });
}

export function startVendorDirectoryImportProcessing(clientViewId, importJobId) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/procesar`, {
    method: "POST",
  });
}

export function cancelVendorDirectoryImportJob(clientViewId, importJobId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/cancelar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function retryVendorDirectoryImportJob(clientViewId, importJobId) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/reintentar`, {
    method: "POST",
  });
}

export function rollbackVendorDirectoryImportJob(clientViewId, importJobId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/${importJobId}/revertir`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function listVendorDirectoryImportCandidates(clientViewId, importJobId, params = {}) {
  return clientPortalRequest(
    `${base(clientViewId)}/importaciones/${importJobId}/candidatos${buildClientQuery(params)}`
  );
}

export function listVendorDirectorySources(clientViewId) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/fuentes`);
}

export function createVendorDirectorySource(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/importaciones/fuentes`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function listVendorDirectoryCandidates(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos${buildClientQuery(params)}`);
}

export function getVendorDirectoryCandidate(clientViewId, candidateId) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}`);
}

export function assignVendorDirectoryCandidate(clientViewId, candidateId, body) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/asignar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function rejectVendorDirectoryCandidate(clientViewId, candidateId, body) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/rechazar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function deferVendorDirectoryCandidate(clientViewId, candidateId, body) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/aplazar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function restoreVendorDirectoryCandidate(clientViewId, candidateId) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/restaurar`, {
    method: "POST",
  });
}

export function acceptVendorDirectoryCandidate(clientViewId, candidateId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/aceptar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function linkVendorDirectoryCandidate(clientViewId, candidateId, body) {
  return clientPortalRequest(`${base(clientViewId)}/candidatos/${candidateId}/vincular`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function vendorDirectoryImportErrorsExportUrl(clientViewId, importJobId) {
  return `${resolveVendorDirectoryApiBase(clientViewId)}/importaciones/${importJobId}/errores/exportar`;
}
